import { pigletRegistrationColors as c } from '../PigletRegistration/colors';

/**
 * Colours for the slaughterhouse readers widget, taken from the dashboard palette rather than picked fresh.
 *
 * The mapping follows the meaning the rest of the overview already gives each colour, so the card reads as
 * part of the page instead of as a second colour system: green for "nothing to do", amber for the warning
 * severity the farm queue marks with `target`, red for the critical severity it marks with `belowExpected`.
 * Anything that is a reference rather than a judgement - the empty ring, the pooled tail - takes the same
 * recessive grey the charts use for gridlines and expected lines.
 */
export const readerStatusColors = {
  healthy: c.neutral,
  stale: c.target,
  down: c.belowExpected,

  /** The empty ring, drawn when there is nothing to plot. */
  track: c.grid,

  /** Every slaughterhouse past the legend, pooled into one slice. */
  other: c.expected
} as const;

/**
 * The dashboard's indigo ramp, darkest first, continued by two lighter steps of the same hue for estates with
 * more than three slaughterhouses. Dark-first because slices are sorted by device count, so the biggest arc
 * takes the strongest colour; and the lightest step still clears 2:1 against a white card.
 */
export const slaughterhouseScale = [
  c.weightClass.heavy,
  c.weightClass.medium,
  c.weightClass.light,
  '#a5b4fc',
  '#c7d2fe'
] as const;

export const slaughterhouseColor = (index: number): string => slaughterhouseScale[index % slaughterhouseScale.length];
